import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  SettingsModal,
  SettingsModalState,
} from '../../interfaces/connected-components/settingsModal';

/**
 * Represents the initial state for the Settings modal slice.
 * @type {SettingsModalState}
 */
const initialState: SettingsModalState = {
  isVisible: false,
  component: null,
  title: '',
};

/**
 * Represents a Redux slice for managing the Settings modal state.
 * @type {Slice<SettingsModalState>}
 */
export const settingsModalSlice = createSlice({
  name: 'settingsModal',
  initialState,
  reducers: {
    /**
     * Action to show the Settings modal with the provided data.
     * @returns {void}
     */
    showSettingsModal: (
      state,
      action: PayloadAction<SettingsModal | undefined>,
    ): void => {
      state.isVisible = true;
      state.component = action?.payload?.component || null;
      state.title = action?.payload?.title || '';
    },
    /**
     * Action to hide the Settings modal.
     * @param {SettingsModalState} state - The current state of the Settings modal.
     * @returns {void}
     */
    hideSettingsModal: (state): void => {
      state.isVisible = false;
    },
  },
});

/**
 * Action creators for the Settings modal slice.
 */
export const {showSettingsModal, hideSettingsModal} =
  settingsModalSlice.actions;

/**
 * The reducer function for the Settings modal slice.
 * @type {Reducer<SettingsModalState>}
 */
export default settingsModalSlice.reducer;
